import React, { useEffect } from "react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { logout } from "../../actions/auth";
import userService from "../../services/user.service";
import Burger from "@animated-burgers/burger-slip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBlog,
  faHome,
  faInfoCircle,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
const HeaderComp = () => {
  const [open, setOpen] = useState(false);
  const [stickyNav, setStickyNav] = useState(false);
  const [mobnav, setMobNav] = useState(false);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [act, setAct] = useState(false);
  const [act2, setAct2] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    userService.getProfile().then(
      (response) => {
        setName(response.data.user.first_name);
        setLoading(false);
      },
      (error) => {
        // console.log(error);
        setLoading(false);
      }
    );

    window.onscroll = () => {
      setStickyNav(window.pageYOffset === 0 ? false : true);
      return () => (window.onscroll = null);
    };
  }, []);
  const Logout = () => {
    dispatch(logout());
  };
  return (
    // start header section
    <div className={`header-container ${stickyNav ? "fixed-top" : ""}`}>
      <nav className="navbar navbar-expand-lg shadow-lg">
        <Link
          to="/"
          className="navbar-brand mx-1 d-lg-none d-flex align-items-center"
        >
          <svg
            width="60"
            height="60"
            viewBox="0 0 178 178"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M77.0674 48.7475L76.7117 51.1079C76.1989 55.5659 71.3499 59.5119 69.3923 60.9357C67.0935 58.1273 67.6312 55.7801 67.8251 55.1815C68.9319 52.0745 73.819 49.8281 77.0674 48.7475Z"
              fill="white"
            ></path>
            <path
              d="M109.166 83.6742C108.399 80.9962 107.021 78.5546 105.145 76.4955C102.877 74.0068 100.232 71.9222 97.6743 69.9064C97.301 69.6123 96.9283 69.3182 96.5629 69.0275C96.2636 68.7878 94.6911 67.4962 93.0354 65.6028L91.7046 63.6695C91.7046 63.6695 92.8619 65.4011 95.4547 65.371L95.4619 65.369C95.4691 65.369 95.475 65.369 95.4822 65.3697C96.331 65.3566 97.3324 65.1542 98.4969 64.6414C99.588 63.9629 100.09 62.9655 100.384 62.1854C100.49 61.9077 100.572 61.7473 100.627 61.6569C101.671 61.5161 102.383 61.0858 102.742 60.3746C102.927 60.0085 102.98 59.6319 102.953 59.2821C103.367 58.8414 103.659 58.195 103.584 57.3226L103.577 57.2473L103.563 57.1726C103.547 57.0947 103.54 57.0148 103.54 56.9342L103.641 57.0213C103.764 57.115 103.882 57.2087 104.003 57.303C104.323 57.5826 104.694 57.9153 105.103 58.2952C111.943 64.6565 115.587 73.5903 115.448 82.79C115.365 81.9635 115.245 81.1318 115.095 80.3112C114.879 79.1919 114.613 78.0929 114.275 77.0274C114.109 76.4942 113.928 75.971 113.729 75.4601C113.535 74.9493 113.328 74.4496 113.104 73.9675C112.671 72.9996 112.17 72.0918 111.667 71.2673C111.171 70.4355 110.639 69.6863 110.122 69.017C109.608 68.3444 109.09 67.7647 108.61 67.2762C108.133 66.7837 107.68 66.3933 107.302 66.0803C106.924 65.7692 106.605 65.5478 106.392 65.4011C106.175 65.257 106.059 65.1811 106.059 65.1811C106.059 65.1811 106.154 65.2813 106.334 65.4699C106.517 65.6572 106.767 65.9414 107.083 66.3049C107.395 66.6723 107.755 67.1301 108.149 67.6665C108.539 68.2055 108.95 68.8336 109.375 69.5304C109.793 70.2305 110.215 71.0053 110.635 71.839C111.055 72.6767 111.443 73.5687 111.813 74.5131C112.18 75.4549 112.51 76.4477 112.802 77.4681C113.091 78.4872 113.341 79.5423 113.535 80.596C114.495 85.8197 112.983 91.4986 114.924 96.5219C115.536 98.1081 116.589 99.6216 118.147 100.302C118.223 100.336 118.301 100.367 118.38 100.395C119.908 100.939 121.846 100.491 122.63 99.0774C122.666 100.641 121.267 101.995 119.724 102.25C118.18 102.506 116.598 101.849 115.395 100.849C110.014 96.3738 110.91 89.7571 109.166 83.6742Z"
              fill="white"
            ></path>
            <path
              d="M61.1029 77.895V76.9284C61.3118 73.4952 61.9124 70.4715 63.1319 68.4392C64.5681 66.094 66.4969 64.084 69.0163 62.651C69.0163 62.651 77.049 57.5649 77.7747 51.2632L78.2364 48.1948C78.2429 48.1496 78.279 48.1143 78.3242 48.1084C79.5069 47.9479 94.1832 45.8109 98.5162 37.3729C96.7014 39.6337 91.4351 44.5083 78.5363 46.8981C78.5363 46.8981 66.5348 49.8603 66.2395 56.2367C66.2395 56.2367 65.1746 49.9566 69.5423 46.0074C70.5142 45.4252 73.6093 25.3857 89.7965 22.4864C91.7619 21.9435 93.8072 21.6809 95.9135 21.7745C104.182 22.14 110.52 29.9951 110.356 38.0612C109.14 37.0362 107.802 36.5175 107.119 36.3001C108.748 36.8385 110.283 38.2524 111.007 39.7489C112.139 42.087 111.309 45.1743 110.779 47.5668C110.687 48.2243 110.665 48.8845 110.88 49.5302C111.153 50.3482 111.682 51.1832 112.707 51.4315C111.005 51.1728 110.321 49.4241 110.183 47.9047C110.116 47.1548 110.149 46.403 110.169 45.6505C110.265 44.7532 110.186 43.9594 110.044 43.3012C110.04 43.2777 110.038 43.2528 110.032 43.2292C110.03 43.22 110.025 43.2037 110.021 43.1925C109.788 42.1833 109.413 41.5257 109.317 41.3823C109.168 41.0948 108.996 40.8112 108.79 40.546C108.434 40.0836 107.987 39.6736 107.487 39.3488C106.984 39.0259 106.427 38.8052 105.87 38.6565C105.311 38.5 104.731 38.4581 104.236 38.4057C103.726 38.3441 103.238 38.2714 102.784 38.1653C102.329 38.0586 101.909 37.9263 101.534 37.7678C101.163 37.606 100.829 37.4351 100.554 37.2484C100.412 37.1594 100.293 37.0592 100.174 36.976C100.064 36.883 99.959 36.7991 99.8692 36.7186C99.7821 36.6354 99.7035 36.5607 99.6361 36.4959C99.568 36.4298 99.5162 36.3669 99.471 36.3197C99.382 36.2222 99.3348 36.1711 99.3348 36.1711C99.3348 36.1711 99.2929 36.2569 99.1979 36.414C99.2647 36.5195 99.3571 36.6518 99.4828 36.8109C99.5601 36.9066 99.6525 37.0054 99.7559 37.1233C99.862 37.2275 99.9753 37.344 100.109 37.4547C100.371 37.6859 100.698 37.9112 101.077 38.1182C101.456 38.3251 101.889 38.5111 102.361 38.6532C102.833 38.7986 103.339 38.9172 103.866 38.9964C103.999 39.0167 104.131 39.0357 104.264 39.0554C104.394 39.0763 104.523 39.0966 104.653 39.1169C104.914 39.1641 105.153 39.2178 105.408 39.2892C105.893 39.4267 106.367 39.6212 106.791 39.8943C106.818 39.9114 106.836 39.9382 106.839 39.9703C106.868 40.2408 106.994 41.6194 106.806 43.5999C106.801 43.6582 106.795 43.7165 106.789 43.7748C106.745 44.1644 106.607 45.1639 106.245 46.289C106.006 47.033 105.652 47.7318 105.248 48.4018C105.185 48.5086 105.12 48.6238 105.058 48.7476C104.509 49.8321 104.098 51.5546 104.973 53.8645C104.98 53.8842 104.982 53.9058 104.978 53.9261C104.851 54.4697 104.335 54.8836 103.727 54.8371L102.719 54.7598C102.683 54.7572 102.649 54.7716 102.628 54.8011C102.456 55.0421 101.693 56.198 101.94 57.4398C102.03 58.4785 101.172 58.6481 101.172 58.6481V58.8066C101.155 59.1616 101.002 60.0221 99.9498 60.3306C99.3564 60.3791 98.991 61.2632 98.824 61.7053C98.3819 62.8756 97.742 63.6085 96.4269 63.9137C93.8564 64.511 90.5745 62.4611 88.0806 60.4269C87.9987 60.3601 87.8802 60.4452 87.9182 60.5441C89.8803 65.5287 94.789 69.5795 95.4236 70.0883C98.3439 72.4068 101.338 74.6532 103.851 77.4117C109.969 84.126 107.926 89.852 101.09 93.0435C101.017 93.0782 101.007 93.1771 101.073 93.2209C102.068 93.8903 107.741 97.8938 112.309 105.075C113.072 106.048 113.763 107.076 114.365 108.158C114.942 109.195 115.406 110.228 115.775 111.261C115.836 111.391 119.064 118.414 118.204 126.716C118.177 126.976 118.146 127.237 118.111 127.499C118.107 127.529 118.091 127.55 118.07 127.565L118.023 127.863C118.042 127.885 118.055 127.912 118.05 127.942L117.984 128.362L117.77 129.468C117.69 129.836 117.599 130.205 117.5 130.575L117.321 130.569C117.266 130.566 117.212 130.56 117.157 130.557C117.046 130.55 116.935 130.542 116.825 130.529C116.76 130.522 116.698 130.511 116.634 130.502C116.377 130.465 116.124 130.412 115.874 130.344C115.733 130.305 115.593 130.26 115.455 130.212C115.425 130.201 115.394 130.193 115.364 130.182C115.03 130.06 114.707 129.91 114.398 129.734C114.344 129.704 114.293 129.67 114.241 129.638C114.143 129.578 114.046 129.52 113.951 129.456C113.829 129.372 113.707 129.284 113.591 129.192C113.946 129.223 114.475 129.305 115.254 129.492C115.411 129.53 115.572 129.549 115.734 129.549C115.762 129.549 115.826 129.548 115.826 129.548C116.489 129.548 117.09 129.299 117.565 128.831C117.855 128.546 117.97 128.14 117.872 127.746C117.773 127.353 117.482 127.048 117.092 126.933C116.605 126.788 116.206 126.637 115.967 126.504C115.398 126.187 114.942 125.973 114.491 125.811C114.225 125.717 113.966 125.631 113.721 125.555C113.074 125.359 112.397 125.259 111.71 125.259C111.33 125.259 110.945 125.289 110.568 125.351C109.267 125.561 106.849 125.912 105.269 125.912C104.976 125.912 104.726 125.9 104.526 125.883C104.526 125.883 104.413 125.877 104.412 125.87C104.384 125.872 104.355 125.872 104.327 125.872L103.795 125.843C103.676 125.821 103.56 125.785 103.443 125.744C103.104 125.622 102.774 125.426 102.461 125.211C102.456 125.207 102.451 125.204 102.445 125.2C102.388 125.16 102.331 125.12 102.275 125.08C102.261 125.069 102.247 125.059 102.233 125.049C102.184 125.013 102.135 124.978 102.087 124.942C102.026 124.897 101.966 124.851 101.906 124.807C101.77 124.705 101.635 124.601 101.499 124.5C100.903 124.051 100.307 123.601 99.7114 123.151L99.0453 122.647L98.8941 122.533L98.8161 122.597L98.8718 122.517C98.7473 122.431 86.4027 113.899 79.9222 109.919L79.8927 109.902L79.8672 109.889L76.6711 108.079L76.2546 107.843C76.6259 104.487 75.6435 91.7998 75.3128 87.7549C75.3135 87.6239 75.3148 87.493 75.3161 87.3613L74.667 88.2029C74.9683 91.9353 76.0535 105.986 75.5132 108.174C75.5217 108.199 75.5388 108.219 75.5617 108.231L79.5449 110.488C79.5521 110.491 79.5593 110.495 79.5659 110.499C86.1066 114.515 98.4841 123.076 98.4841 123.076C99.49 123.835 100.494 124.595 101.497 125.35C102.16 125.849 102.856 126.362 103.672 126.511C103.928 126.559 104.185 126.564 104.445 126.551C105.921 126.731 109.053 126.284 110.676 126.022C111.628 125.869 112.602 125.926 113.523 126.207C113.784 126.286 114.035 126.371 114.262 126.452C114.74 126.623 115.194 126.851 115.637 127.098C115.991 127.294 116.5 127.466 116.899 127.585C117.233 127.684 117.336 128.103 117.088 128.347C116.815 128.616 116.398 128.874 115.803 128.867C115.678 128.874 115.549 128.863 115.413 128.831C111.855 127.973 112.414 129.031 112.414 129.031C113.656 130.358 115.43 131.17 117.246 131.246C117.278 131.247 117.308 131.263 117.326 131.291C117.521 131.597 118.587 133.429 116.513 133.797C116.448 133.809 116.407 133.877 116.434 133.937C116.641 134.412 117.259 136.153 115.231 136.214C115.164 136.215 115.115 136.276 115.131 136.34C115.232 136.732 115.441 137.931 114.403 138.413C113.661 138.759 114.172 139.713 113.177 139.963C112.041 140.248 110.632 140.395 109.576 139.787C109.093 139.581 108.626 139.315 108.203 139.028C105.789 137.388 103.8 135.24 101.535 133.417C99.103 131.459 96.3975 130.447 93.673 129.009C87.11 125.544 80.547 122.567 74.4418 118.301C70.7558 115.727 66.7163 113.207 65.3173 108.667C64.798 106.982 64.3349 105.271 63.8948 103.552C63.8641 103.414 60.6379 88.9685 61.0512 77.9789C61.0525 77.9402 61.0741 77.9114 61.1029 77.895"
              fill="white"
            ></path>
            <path
              d="M104.455 126.547L104.443 126.551L104.445 126.547H104.455Z"
              fill="white"
            ></path>
            <path
              d="M68.8016 162.257C64.3913 156.314 60.4939 147.251 63.815 135.544C63.9899 134.889 64.1955 134.228 64.4359 133.562C65.2067 131.424 66.3214 129.232 67.8435 126.993C68.2109 126.452 68.6228 125.945 69.0525 125.452C69.8488 124.537 71.4645 122.081 70.8823 117.707C71.6604 118.285 72.46 118.839 73.2532 119.388C73.521 119.573 73.7876 119.758 74.0522 119.944C78.7159 123.201 83.7385 125.762 88.5954 128.239C90.1548 129.035 91.7685 129.857 93.3561 130.696C94.1263 131.102 94.8991 131.477 95.6457 131.839C97.5843 132.779 99.4154 133.668 101.109 135.032C101.98 135.733 102.832 136.503 103.655 137.247C104.962 138.429 106.313 139.652 107.821 140.675C109.04 141.502 110.168 141.922 111.176 141.922C111.226 141.922 111.274 141.917 111.324 141.915C111.37 141.916 111.418 141.922 111.465 141.922C111.644 141.922 111.818 141.905 111.988 141.878C109.737 144.217 106.787 146.397 102.95 148.274C102.95 148.274 99.0251 149.973 100.385 154.053L105.518 163.375C139.67 155.991 165.261 125.611 165.261 89.2486C165.261 47.3609 131.304 13.4036 89.4154 13.4036C47.5277 13.4036 13.5711 47.3609 13.5711 89.2486C13.5711 123.992 36.9316 153.276 68.8016 162.257ZM89.4154 0.815994C138.256 0.815994 177.849 40.4088 177.849 89.2486C177.849 138.089 138.256 177.681 89.4154 177.681C40.5757 177.681 0.983459 138.089 0.983459 89.2486C0.983459 40.4088 40.5757 0.815994 89.4154 0.815994Z"
              fill="white"
            ></path>
          </svg>
          <span className="logo-title">Healthy Pregnancy</span>
        </Link>
        <div className="d-flex align-items-center">
          {!loading ? (
            name ? (
              <div
                className={`nav-item dropdown_menu  nav-item-mob mx-1 ${
                  open ? "activeprofile" : ""
                }`}
                onClick={() => {
                  setOpen((open) => !open);
                  setAct(true);
                }}
              >
                <div
                  className="login-nav-item"
                  onClick={() => {
                    setMobNav(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.0"
                    width="40"
                    height="40"
                    viewBox="0 0 512.000000 512.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      fill="white"
                      stroke="none"
                    >
                      <path d="M2285 4908 c-128 -13 -319 -52 -471 -98 -499 -149 -948 -460 -1279 -885 -455 -586 -632 -1351 -481 -2077 138 -658 521 -1227 1085 -1607 l63 -43 30 38 c55 69 193 197 277 258 111 80 301 174 444 220 l117 38 0 35 0 35 -37 -7 c-115 -21 -233 3 -344 71 -106 64 -257 227 -274 297 -8 32 31 77 68 77 45 0 130 53 170 105 42 56 92 177 110 268 12 59 12 63 -29 186 -61 182 -78 279 -76 451 3 548 269 1028 659 1190 74 31 80 32 227 31 164 0 228 -11 319 -57 272 -137 486 -454 566 -840 61 -297 43 -547 -59 -824 l-32 -85 23 -85 c47 -183 133 -303 234 -329 81 -20 100 -32 103 -70 4 -42 -27 -91 -122 -190 -129 -135 -263 -202 -402 -203 -40 0 -82 3 -94 7 -20 6 -21 4 -18 -30 l3 -38 115 -38 c140 -46 284 -117 407 -199 90 -60 240 -197 301 -274 l30 -38 63 43 c560 377 948 951 1084 1605 124 594 30 1216 -263 1749 -216 392 -542 730 -927 962 -320 193 -693 317 -1059 352 -128 13 -402 12 -531 -1z" />
                    </g>
                  </svg>
                </div>
                {/* {open && ( */}
                <ul
                  className={`position-absolute ${
                    open ? "animate__zoomIn" : "d-none"
                  }  animate__animated`}
                >
                  <li>
                    <NavLink to="/profile" className="text-white">
                      Profile
                    </NavLink>
                  </li>
                  <li onClick={Logout}>Log out</li>
                </ul>
                {/* )} */}
              </div>
            ) : (
              <NavLink to="/login" className="nav-item-mob login-nav-item">
                <svg
                  // xmlns="http://www.w3.org/2000/svg"
                  // xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  width="35"
                  height="35"
                  viewBox="0 0 256 256"
                  xmlSpace="preserve"
                >
                  <defs></defs>
                  <g
                    style={{
                      stroke: "none",
                      strokeWidth: "0",
                      strokeDasharray: "none",
                      strokeLinecap: "butt",
                      strokeLinejoin: " miter",
                      strokeMiterlimit: "10",
                      fill: "none",
                      fillRule: "nonzero",
                      opacity: "1",
                    }}
                    transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                  >
                    <path
                      d="M 36.137 34.78 c -9.589 0 -17.39 -7.801 -17.39 -17.39 C 18.747 7.801 26.548 0 36.137 0 s 17.39 7.801 17.39 17.39 C 53.527 26.979 45.726 34.78 36.137 34.78 z M 36.137 7 c -5.729 0 -10.39 4.661 -10.39 10.39 s 4.661 10.39 10.39 10.39 s 10.39 -4.661 10.39 -10.39 S 41.866 7 36.137 7 z"
                      style={{
                        stroke: "none",
                        strokeWidth: "1",
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: " miter",
                        strokeMiterlimit: "10",
                        fill: "white",
                        fillRule: "nonzero",
                        opacity: "1",
                      }}
                      transform=" matrix(1 0 0 1 0 0) "
                      strokeLinecap="round"
                    />
                    <path
                      d="M 11.721 90 c -1.933 0 -3.5 -1.567 -3.5 -3.5 V 61.756 c 0 -11.14 9.063 -20.203 20.203 -20.203 h 15.427 c 6.92 0 13.29 3.505 17.039 9.375 c 1.084 1.698 1.904 3.539 2.438 5.471 c 0.516 1.862 -0.577 3.791 -2.44 4.306 c -1.86 0.519 -3.791 -0.576 -4.306 -2.44 c -0.349 -1.258 -0.884 -2.459 -1.593 -3.568 c -2.456 -3.847 -6.62 -6.143 -11.138 -6.143 H 28.424 c -7.28 0 -13.203 5.923 -13.203 13.203 V 86.5 C 15.221 88.433 13.654 90 11.721 90 z"
                      style={{
                        stroke: "none",
                        strokeWidth: "1",
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: " miter",
                        strokeMiterlimit: "10",
                        fill: "white",
                        fillRule: "nonzero",
                        opacity: "1",
                      }}
                      transform=" matrix(1 0 0 1 0 0) "
                      strokeLinecap="round"
                    />
                    <path
                      d="M 60.554 90 c -1.933 0 -3.5 -1.567 -3.5 -3.5 v -2.236 c 0 -1.933 1.567 -3.5 3.5 -3.5 s 3.5 1.567 3.5 3.5 V 86.5 C 64.054 88.433 62.486 90 60.554 90 z"
                      style={{
                        stroke: "none",
                        strokeWidth: "1",
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: " miter",
                        strokeMiterlimit: "10",
                        fill: "white",
                        fillRule: "nonzero",
                        opacity: "1",
                      }}
                      transform=" matrix(1 0 0 1 0 0) "
                      strokeLinecap="round"
                    />
                    <path
                      d="M 33.663 68.741 l 8.515 -8.515 c 1.367 -1.367 3.582 -1.367 4.949 0 c 1.367 1.366 1.367 3.583 0 4.949 l -2.54 2.54 h 33.693 c 1.933 0 3.5 1.567 3.5 3.5 s -1.567 3.5 -3.5 3.5 H 44.586 l 2.541 2.541 c 1.367 1.367 1.367 3.583 0 4.949 c -0.684 0.684 -1.579 1.025 -2.475 1.025 s -1.792 -0.342 -2.475 -1.025 l -8.515 -8.516 C 32.295 72.323 32.295 70.107 33.663 68.741 z"
                      style={{
                        stroke: "none",
                        strokeWidth: "1",
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: " miter",
                        strokeMiterlimit: "10",
                        fill: "white",
                        fillRule: "nonzero",
                        opacity: "1",
                      }}
                      transform=" matrix(1 0 0 1 0 0) "
                      strokeLinecap="round"
                    />
                  </g>
                </svg>
              </NavLink>
            )
          ) : (
            <div className="nav-item login-nav-item nav-item-mob">
              <span className="spinner-border text-light spinner-border-sm"></span>
            </div>
          )}

          <Burger
            Component="div"
            isOpen={mobnav}
            direction="right"
            onClick={() => {
              setMobNav((mobnav) => !mobnav);
              setOpen(false);
              setAct2(true);
            }}
            className="mx-3 d-lg-none"
          />
        </div>

        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <Row className="m-0">
            <Col lg="12" className="py-5">
              <div className="nav-container">
                <NavLink to="/" end className="nav-item">
                  Home
                </NavLink>
                <NavLink to="/aboutus" end className="nav-item">
                  About Us
                </NavLink>
                <NavLink to="/blog" end className="nav-item">
                  Blog
                </NavLink>
                {!loading ? (
                  name ? (
                    <div
                      className={`nav-item dropdown_menu ${
                        open ? "activeprofile" : ""
                      }`}
                      onClick={() => {
                        setOpen((open) => !open);
                        setAct(true);
                      }}
                    >
                      <div className="login-nav-item">{name}</div>
                      {/* {open && ( */}
                      <ul
                        className={`position-absolute ${
                          open
                            ? "animate__zoomIn"
                            : act
                            ? "animate__zoomOut"
                            : "d-none"
                        }  animate__animated`}
                      >
                        <li>
                          <NavLink to="/profile" className="text-white">
                            Profile
                          </NavLink>
                        </li>
                        <li onClick={Logout}>Log out</li>
                      </ul>
                      {/* )} */}
                    </div>
                  ) : (
                    <NavLink to="/login" className="nav-item login-nav-item">
                      Login
                    </NavLink>
                  )
                ) : (
                  <div className="nav-item login-nav-item">
                    <span className="spinner-border text-light spinner-border-sm"></span>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </nav>
      <div
        className={`header-mobile-container ${
          mobnav
            ? "animate__slideInRight"
            : act2
            ? "animate__slideOutRight"
            : "d-none"
        } animate__animated`}
      >
        <ul>
          <li>
            <NavLink
              to="/"
              end
              onClick={() => {
                setMobNav((mobnav) => !mobnav);
              }}
            >
              <FontAwesomeIcon icon={faHome} className="mx-2" size="lg" />
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/aboutus"
              end
              onClick={() => {
                setMobNav((mobnav) => !mobnav);
              }}
            >
              <FontAwesomeIcon icon={faInfoCircle} className="mx-2" size="lg" />
              About Us
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/blog"
              end
              onClick={() => {
                setMobNav(false);
              }}
            >
              <FontAwesomeIcon icon={faBlog} className="mx-2" size="lg" />
              Blog
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/babycheck"
              end
              onClick={() => {
                setMobNav(false);
              }}
            >
              <svg
                width="25"
                height="25"
                className="mx-1"
                viewBox="0 0 128 128"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M47.5779 2.72794C36.1239 5.76393 27.4299 11.2839 17.9079 21.2199C7.41987 32.3979 2.03787 44.5419 0.933871 59.1699C-1.96413 99.3279 33.2259 132.31 72.9699 126.514C86.7699 124.582 96.9819 119.476 107.332 109.54C127.48 90.2199 132.862 61.1019 120.994 36.3999C116.44 26.8779 104.434 14.1819 95.0499 8.79993C81.6639 1.07193 62.6199 -1.27406 47.5779 2.72794ZM78.4899 8.10993C121.546 19.2879 136.174 73.3839 104.848 104.848C82.3539 127.204 45.6459 127.204 23.1519 104.848C10.5939 92.1519 4.10787 73.1079 6.86787 56.2719C7.97187 49.2339 8.52387 48.1299 11.2839 47.7159C16.8039 46.8879 22.3239 50.1999 28.1199 57.9279C31.1559 61.9299 34.8819 65.9319 36.3999 66.7599C39.4359 68.4159 40.1259 70.8999 37.5039 70.8999C34.4679 70.8999 30.8799 75.4539 30.8799 79.1799C30.8799 81.2499 32.8119 85.5279 35.0199 88.7019C38.6079 93.5319 38.8839 94.7739 37.5039 97.1199C35.4339 100.432 37.2279 104.434 41.0919 105.124C44.9559 105.952 50.1999 100.018 50.1999 94.9119C50.1999 90.4959 50.3379 90.3579 54.4779 91.8759C61.2399 94.2219 72.6939 92.5659 78.9039 88.4259C85.5279 83.7339 90.4959 75.1779 90.9099 67.4499C91.1859 62.7579 92.2899 60.4119 96.1539 56.5479C101.812 50.8899 103.192 47.4399 102.088 41.5059C100.432 33.2259 90.6339 25.3599 81.8019 25.3599C76.2819 25.3599 69.2439 29.4999 64.9659 35.2959C61.1019 40.4019 60.2739 51.8559 63.3099 56.5479C66.2079 61.1019 65.1039 62.3439 60.6879 59.4459C58.2039 57.7899 57.0999 55.7199 56.8239 51.9939C56.4099 47.4399 55.9959 46.7499 52.9599 46.7499C49.7859 46.7499 49.5099 47.1639 49.5099 54.0639C49.5099 57.9279 48.9579 61.2399 48.2679 61.2399C47.5779 61.2399 42.1959 56.2719 36.3999 50.3379C28.5339 42.3339 24.1179 38.8839 19.9779 37.6419C16.9419 36.6759 14.3199 35.5719 14.3199 35.0199C14.3199 32.6739 23.1519 22.1859 28.5339 18.3219C44.1279 6.86794 60.6879 3.55593 78.4899 8.10993Z"
                  fill="white"
                ></path>
              </svg>
              Baby Check
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
    // end header section
  );
};

export default HeaderComp;
